import styled from 'styled-components'

const sizes = { small: 1366, medium: 1600 }

export const Container = styled.div`
  position: relative;

  display: flex;
  height: 73%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 812px) {
    height: auto;
    width: 100%;
  }
`

export const Image = styled.img`
  display: block;
  width: 1350px;
  height: auto;
  border-radius: 5px;
  box-shadow: 1px 0px 25px rgba(0, 0, 100, 0.5);

  @media screen and (max-width: ${sizes.medium}px){
    width: 1100px;
  }

  @media screen and (max-width: ${sizes.small}px){
    width: 965px;
  }

  @media screen and (max-width: 812px) {
    height: auto;
    margin: 1em;
    width: 100%;
  }  
`

export const Message = styled.div`
  display: block;
  width: 90%;
  margin: 1em;
  justify-content: center;
  align-items: center;

  text-decoration: none;
  font-family: 'Barthowheel-Regular';
  text-align: center;
  font-size: 1em;
  transform: scaleX(0.85);
  color: #FFF;

  @media screen and (max-width: 812px) {
    height: auto;
    margin: 1em;
    width: 100%;
  }
`

export const MobileMessage = styled.div`
  display: none;

  @media screen and (max-width: 812px) {
    display: block;
    width: 100%;
    margin-bottom: 1em;
    justify-content: center;
    align-items: center;

    text-decoration: none;
    font-family: 'Barthowheel-Regular';
    text-align: right;
    font-size: 0.7em;
    color: #FFF;
  }
`

export const NoPitStop = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;

  text-decoration: none;
  font-family: 'Crash';
  text-align: center;
  font-size: 2em;
  transform: scaleX(0.85);
  color: #FFF;

  @media screen and (max-width: 812px) {
    margin: 0;
    width: 100%;
    height: 111px;
  }
`